// extracted by mini-css-extract-plugin
module.exports = {"container":"CouponChange_container__BqloY"};